import { Injectable, signal } from '@angular/core';

/**
 * Brand colours shared by the workspace (theme restore on start-up, dashboard chart strokes) and
 * Settings > Branding & Portal.
 *
 * Provided on `PmWorkspaceComponent` (not root) so it lives and dies with the workspace,
 * exactly like the signals it replaced.
 */
@Injectable()
export class PmBrandingStateService {
  readonly defaultPrimaryBrandColor = '#694baf';
  readonly primaryBrandColor = signal<string>(this.defaultPrimaryBrandColor);
  /** Client portal branding only — does not change app theme CSS. */
  readonly portalBrandingPrimaryColor = signal<string>(this.defaultPrimaryBrandColor);
  readonly emailHeaderColor = signal<string>(this.defaultPrimaryBrandColor);
}
